export type PrimarySportStoredValue =
    | 'baseball'
    | 'softball'
    | 'football'
    | 'soccer'
    | 'track'
    | 'multi_sport';

export type PrimarySportOptionId =
    | 'none'
    | 'baseball'
    | 'softball'
    | 'football'
    | 'soccer'
    | 'track'
    | 'performance_training';

export type PrimarySportOption = {
    id: PrimarySportOptionId;
    label: string;
    storedValue?: PrimarySportStoredValue;
};

export const PRIMARY_SPORT_OPTIONS: PrimarySportOption[] = [
    { id: 'none', label: 'Deselect all' },
    { id: 'baseball', label: 'Baseball', storedValue: 'baseball' },
    { id: 'football', label: 'Football', storedValue: 'football' },
    { id: 'track', label: 'Track', storedValue: 'track' },
    { id: 'soccer', label: 'Soccer', storedValue: 'soccer' },
    { id: 'softball', label: 'Softball', storedValue: 'baseball' },
    { id: 'performance_training', label: 'Performance Training', storedValue: 'multi_sport' },
];

export const mapOptionIdToPrimarySportValue = (
    optionId: PrimarySportOptionId,
): PrimarySportStoredValue | null => {
    if (optionId === 'none') {
        return null;
    }
    const match = PRIMARY_SPORT_OPTIONS.find((option) => option.id === optionId);
    return match?.storedValue || 'track';
};

export const mapPrimarySportValueToOptionId = (
    value: string | null | undefined,
): PrimarySportOptionId => {
    if (!value) {
        return 'none';
    }
    switch (value) {
        case 'football':
            return 'football';
        case 'track':
            return 'track';
        case 'soccer':
            return 'soccer';
        case 'multi_sport':
            return 'performance_training';
        case 'softball':
            return 'softball';
        case 'baseball':
        default:
            return 'baseball';
    }
};
